<script setup lang="ts">
import AppHeaderNavLink from '@/modules/App/AppHeaderNavLink.vue'
import { FeatureFlag } from '@/modules/App/featureFlags'
import { useFeatureFlags } from '@/modules/App/useFeatureFlags'
import HubAddDataButton from '@/modules/Workspaces/KnowledgeHub/Hubs/HubAddDataButton.vue'
import AppHeader from '@/sharedComponents/AppHeader.vue'
import CrumbChevron from '@/sharedComponents/CrumbChevron.vue'
import CrumbItem from '@/sharedComponents/CrumbItem.vue'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import { useRoute } from 'vue-router'

defineProps<{ hideLinks?: boolean }>()

const route = useRoute()
const isHubsActive = useFeatureFlags(FeatureFlag.HUBS)
</script>

<template>
  <AppHeader>
    <template #crumbs>
      <CrumbItem :to="{ name: 'WorkspaceProjects' }"> Home </CrumbItem>
      <CrumbChevron />
      <CrumbItem active> Knowledge Hub </CrumbItem>
    </template>

    <template v-if="!hideLinks">
      <div class="flex w-[270px] justify-center gap-1">
        <AppHeaderNavLink
          v-if="isHubsActive"
          :exact="false"
          class="w-1/3"
          :to="{ name: 'Hubs' }"
        >
          Hubs
        </AppHeaderNavLink>
        <AppHeaderNavLink
          class="w-1/3"
          :to="{ name: 'Files' }"
        >
          Library
        </AppHeaderNavLink>
        <AppHeaderNavLink
          class="w-1/3"
          :to="{ name: 'Integrations' }"
        >
          Integrations
        </AppHeaderNavLink>
      </div>
    </template>

    <template #actions>
      <template v-if="route.name === 'Hubs'">
        <DarwinButton
          variant="black"
          size="sm"
          rounded
        >
          Create hub
        </DarwinButton>
      </template>
      <template v-else-if="route.name === 'Hub'">
        <DarwinButton
          variant="outline"
          size="sm"
          rounded
          :to="{ name: 'NewCase', query: { hub: 'hub-id' } }"
        >
          Start new case
        </DarwinButton>
        <HubAddDataButton />
      </template>
    </template>
  </AppHeader>
</template>
